import * as React from 'react';
import { observer } from 'src/utils/mobx-react';
import { SvgIcon, SvgIconPropsType } from 'src/ui/assets/icons/utils';

export const ChartIcon = observer('ChartIcon', ({ className, onClick }: SvgIconPropsType): JSX.Element => {
    return (
        <SvgIcon
            className={className}
            onClick={onClick}
            fillRule='evenodd'
            height='24'
            viewBox='0 0 24 24'
            width='24'
            xmlns='http://www.w3.org/2000/svg'
            data-test='chart-icon'
        >
            <path
                fill='currentcolor'
                d='M9 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v17H9V5ZM16 11a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v11h-6V11ZM3 14a1 1 0 0 0-1 1v7h6v-7a1 1 0 0 0-1-1H3Z'
            />
        </SvgIcon>
    );
});
